import { render, staticRenderFns } from "./RulesNumberInput.vue?vue&type=template&id=b0725dcc&scoped=true"
import script from "./RulesNumberInput.vue?vue&type=script&lang=ts"
export * from "./RulesNumberInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0725dcc",
  null
  
)

export default component.exports